import { render, staticRenderFns } from "./defaultSelect.vue?vue&type=template&id=8cb23780&scoped=true"
import script from "./defaultSelect.vue?vue&type=script&lang=js"
export * from "./defaultSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb23780",
  null
  
)

export default component.exports